import React from 'react';
import { Helmet } from 'react-helmet';
import {
  filter,
  range,
  map,
  union,
  isUndefined,
  size,
  toString,
  omit,
  replace,
  forEach,
  cloneDeep,
  isEmpty
} from 'lodash';
import { Button, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { url } from '../../constants/routes';

import './styles.css';
import sdk from '../../qoc-sdk';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import TextHero from '../../components/TextBanner';
import PropTypes from 'prop-types';
import {
  connect as reduxConnect,
  actions as allActions
} from '../../reducers/index';
//import Options from './options'

class TrainingCompletedPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      adviceText: '',
      showAdvice: false,
      role:
        JSON.parse(JSON.parse(localStorage.getItem('role')).value) || 'NONE',
      campus:
        JSON.parse(JSON.parse(localStorage.getItem('campus')).value) || 'NONE',
      instanceLinkUUID:
        JSON.parse(
          JSON.parse(localStorage.getItem('instanceLinkUUID')).value
        ) || 'NONE'
    };
    this.onClickOption = this.onClickOption.bind(this);
    this.onClickSubmit = this.onClickSubmit.bind(this);
  }

  handleChange = event => {
    this.setState({
      adviceText: event.target.value
    });
  };

  onClickOption(event) {
    if (
      event.target.name === 'FB76A1FB-52A1-4C35-9025-E4C0DF8EB81F' &&
      event.target.value == '0'
    ) {
      this.setState({
        showAdvice: true
      });
    }

    if (
      event.target.name === 'FB76A1FB-52A1-4C35-9025-E4C0DF8EB81F' &&
      event.target.value == '1'
    ) {
      this.setState({
        showAdvice: false
      });
    }

    if (event.target.id === 'checkbox') {
      const currentState = cloneDeep(this.state);
      if (currentState[event.target.value] && currentState[event.target.value].surveyLinkUUID) {
        //remove surveyLinkUUID so it will not post
        this.setState({
          [event.target.value]: {
            value: event.target.value,
          }
        });
      } else {
        this.setState({
          [event.target.value]: {
            surveyLinkUUID: event.target.name,
            value: event.target.value,
            id: "checkbox"
          }
        });
      }
    } else {
      this.setState({
        [event.target.name]: {
          surveyLinkUUID: event.target.name,
          value: event.target.value,
        }
      });
    }
  }
  onClickSubmit() {
    const { cache } = this.props;
    const { campus, role } = this.state;

    this.props.onTrainingCompleted();
    const responsesToPost = filter(this.state, item => {
      if (!isUndefined(item.surveyLinkUUID)) {
        return item;
      }
    });
    const propsToPost = map(responsesToPost, item => {
      const propToPost = {
        surveyLinkUUID: item.surveyLinkUUID,
        instanceLinkUUID: this.state.instanceLinkUUID,
        responseSetId: `${campus}-${role}`,
        recordChangeDateTime: new Date().getTime(),
        responseDataType: 'numeric',
      };

      if (item.id === 'checkbox'
		|| item.surveyLinkUUID.includes('likertScale')) {
        propToPost['responseOptionUUID'] = item.value
      } else {
        propToPost[sdk.utils.getResponseKey({ responseDataType: 'numeric' })] = item.value
      }
      return propToPost;
    });
    const roleProps = map(
      filter(cache.questions, question => {
        if (question.questionID === 'role') {
          return question;
        }
      }),
      item => {
        const propToPost = {
          surveyLinkUUID: item.surveyLinkUUID,
          instanceLinkUUID: this.state.instanceLinkUUID,
          responseSetId: `${campus}-${role}`,
          recordChangeDateTime: new Date().getTime(),
          responseDataType: 'string',
          [sdk.utils.getResponseKey({ responseDataType: 'string' })]: this.state
            .role
        };
        return propToPost;
      }
    );
    const campusProps = map(
      filter(cache.questions, question => {
        if (question.questionID === 'campus') {
          return question;
        }
      }),
      item => {
        const propToPost = {
          surveyLinkUUID: item.surveyLinkUUID,
          instanceLinkUUID: this.state.instanceLinkUUID,
          responseSetId: `${campus}-${role}`,
          recordChangeDateTime: new Date().getTime(),
          responseDataType: 'string',
          [sdk.utils.getResponseKey({ responseDataType: 'string' })]: this.state
            .campus
        };
        return propToPost;
      }
    );
    const finalPropsToPost = union(campusProps, roleProps, propsToPost);
    const adviceResponse = {
      instanceLinkUUID: this.state.instanceLinkUUID,
      responseDataType: 'string',
      responseSetId: `${campus}-${role}`,
      surveyLinkUUID: 'A98B0525-3577-404A-80F0-8D3D6090942B',
      responseString: this.state.adviceText
    };

    if (this.state.adviceText.length > 0) {
      sdk.postPutSurveyResponsesNoCache({ surveyResponses: [adviceResponse] });
    }

    sdk
      .postPutSurveyResponsesNoCache({ surveyResponses: finalPropsToPost })
      .then(fulfilprops => {
        if (fulfilprops.status === 200) {
          this.context.router.history.push(url.THANK_YOU);
        }
      });
  }

  render() {
    const { role, cache } = this.props;
	let Options = cache.options.options;

	// Manoj 20240710: The options for post quetionnaire questions are same as pre questionnaire, 		so just duplicate them

    const renderQuestions = filter(cache.questions, question => {
      if (
        (question.questionID.indexOf('post') !== -1 ||
        question.questionID === 'advice')
		&& question.deleted == false	
      ) {
        return question;
      }
    }).map((question, index) => {
      if (!this.state.showAdvice 
			&& question.questionID === 'advice') {
        return null;
      }

      let renderOptions;
      if (question.questionID === 'advice') {
        renderOptions = (
          <textarea
            style={{ width: '100%', height: '100%', border: 'none' }}
            placeholder="Please enter some advice for future improvement"
            onChange={this.handleChange}
            value={this.state.adviceText}
          />
        );
      }
      if (question.questionID.indexOf('analogScale') !== -1) {
        const legend = {
          1: "Strongly Disagree",
          2: "Disagree",
          3: "Neutral",
          4: "Agree",
          5: "Strongly Agree",
        };

        renderOptions = map(
          range(1, question.maxValue + 1),
          (option, optionIndex) => {
            return (
              <label
                key={option}
                className="radio-inline"
                onClick={this.onClickOption}
              >
                <input
                  type="radio"
                  aria-checked={
                    !isUndefined(this.state[question.surveyLinkUUID]) &&
                      toString(this.state[question.surveyLinkUUID].value) ===
                      toString(option)
                      ? 'true'
                      : 'false'
                  }
                  id={question.responseDataType}
                  name={question.surveyLinkUUID}
                  value={option}
                  tabIndex={optionIndex === 0 ? '0' : '-1'}
                />
                {option}
                <br />
                {legend[option]}
              </label>
            );
          }
        );
      }

	  // Unused
      if (question.questionID.indexOf('checkbox') !== -1) {
        renderOptions = map(
          Options[question.questionID],
          (option) => {
            return (
              <label
                key={option}
                style={{ marginLeft: 0 }}
                className="radio-inline"
                onClick={this.onClickOption}
              >
                <input
                  type="checkbox"
                  id={'checkbox'}
                  name={question.surveyLinkUUID}
                  value={option.optionUUID}
                />&nbsp;
                {option.optionText}
              </label>
            );
          }
        );
      }

	  // Unused
      if (question.questionID === 'boolean_post_9') {
        renderOptions = (
          <div>
            <label className="radio-inline" onClick={this.onClickOption}>
              <input
                type="radio"
                aria-checked={
                  !isUndefined(this.state[question.surveyLinkUUID])
                    ? this.state[question.surveyLinkUUID].value === '1'
                      ? 'true'
                      : 'false'
                    : 'false'
                }
                id={question.responseDataType}
                name={question.surveyLinkUUID}
                value={1}
                tabIndex="0"
              />
              Yes
            </label>
            <label className="radio-inline" onClick={this.onClickOption}>
              <input
                type="radio"
                aria-checked={
                  !isUndefined(this.state[question.surveyLinkUUID])
                    ? this.state[question.surveyLinkUUID].value === '0'
                      ? 'true'
                      : 'false'
                    : 'false'
                }
                id={question.responseDataType}
                name={question.surveyLinkUUID}
                value={0}
                tabIndex="-1"
              />
              No
            </label>
          </div>
        );
      }

	// Manoj 20240709: Adding support for likert scale type options
	if (question.questionID.indexOf('likert') !== -1) {

		const legend = {
		  1: "Yes",
		  2: "No",
		  3: "Not Sure"
		}
		renderOptions = map( Options[question.questionID],
		  (option) => {
			return (
				// Manoj 20240704: Loop through questions. Render a row for each question.
			  <tr>
				<td>
					  {option.optionText}
				</td>
				{map(legend, (legendVal) => {
						// Manoj 20240704: Loop through the legend and render each cell
						return(
						<td>
							  <label key={option.optionUUID} style={{ marginLeft: 0 }} className="likert-option-cell" onClick={this.onClickOption} >
								<input type="radio" id={''} name={`[${question.questionID}][${option.optionUUID}]`} value={legendVal} />&nbsp;&nbsp;{legendVal}&nbsp;&nbsp;&nbsp;&nbsp;
							  </label>
						</td>
						)
				})}
			  </tr>
			);
		  }
		);
		renderOptions = <table>{renderOptions}</table>;
	}

      let questionText = question.questionText;

      return (
        <div style={{ marginBottom: '30px' }} key={questionText}>
          <p style={{ fontWeight: "bold" }}>{`${index + 1}. ${questionText}`}</p>

          <div
            style={{
              display: question.questionID.indexOf('checkbox') !== -1 ? '' : 'flex',
              justifyContent: 'space-around',
              border: '1px solid #D5D5D5',
              padding: '10px'
            }}
          >
            {renderOptions}
          </div>
        </div >
      );
    });

    const checkAnswered = () => {
	console.log("checkAnswered");
	console.log("This.state = ");
	console.log(this.state);
	console.log("This.state object keys: ");
	console.log(Object.keys(this.state));
	let stateKeys = Object.keys(this.state);
	window.statekeys = stateKeys;

	const q1answered = filter(stateKeys, item => item.includes("question_1")).length > 0;

	const q2Opt1answered = filter(stateKeys, item => item.includes("question_2][opt_1")).length > 0;
	const q2Opt2answered = filter(stateKeys, item => item.includes("question_2][opt_2")).length > 0;
	const q2Opt3answered = filter(stateKeys, item => item.includes("question_2][opt_3")).length > 0;
	const q2Opt4answered = filter(stateKeys, item => item.includes("question_2][opt_4")).length > 0;
	const q2Opt5answered = filter(stateKeys, item => item.includes("question_2][opt_5")).length > 0;
	const q2answered = q2Opt1answered && q2Opt1answered && q2Opt3answered && q2Opt4answered && q2Opt5answered;

	const q3answered = filter(stateKeys, item => item.includes("question_3")).length > 0;

	const q4Opt1answered = filter(stateKeys, item => item.includes("question_4][opt_1")).length > 0;
	const q4Opt2answered = filter(stateKeys, item => item.includes("question_4][opt_2")).length > 0;
	const q4Opt3answered = filter(stateKeys, item => item.includes("question_4][opt_3")).length > 0;
	const q4Opt4answered = filter(stateKeys, item => item.includes("question_4][opt_4")).length > 0;
	const q4Opt5answered = filter(stateKeys, item => item.includes("question_4][opt_5")).length > 0;
	const q4answered = q4Opt1answered && q4Opt1answered && q4Opt3answered && q4Opt4answered && q4Opt5answered;

	const q5answered = filter(stateKeys, item => item.includes("question_5")).length > 0;

	const q6Opt1answered = filter(stateKeys, item => item.includes("question_6][opt_1")).length > 0;
	const q6Opt2answered = filter(stateKeys, item => item.includes("question_6][opt_2")).length > 0;
	const q6Opt3answered = filter(stateKeys, item => item.includes("question_6][opt_3")).length > 0;
	const q6Opt4answered = filter(stateKeys, item => item.includes("question_6][opt_4")).length > 0;
	const q6Opt5answered = filter(stateKeys, item => item.includes("question_6][opt_5")).length > 0;
	const q6answered = q6Opt1answered && q6Opt1answered && q6Opt3answered && q6Opt4answered && q6Opt5answered;
	
		
	
	console.log("q1answered = ");
	console.log(q1answered);
	console.log("q2answered = ");
	console.log(q2answered);
	console.log("q3answered = ");
	console.log(q3answered);
	console.log("q4answered = ");
	console.log(q4answered);
	console.log("q5answered = ");
	console.log(q5answered);
	console.log("q6answered = ");
	console.log(q6answered);


	let allAnswered =  q1answered && q2answered && q3answered && q4answered && q5answered && q6answered; 

	console.log("allAnswered = ");
	console.log(allAnswered);
	
	return allAnswered;
	
    };

    return (
      <div className="education-module" >
		  <style>
		  {`
		     /* Manoj 20240704 - Disclaimer: Tried to move this to style.scss in this directory, but wasn't loading on the browser, so i'm adding this here for now. Please, move this out in the future..*/

		    .likert-option-cell{
		        text-wrap: nowrap;	
		    }	
		`}
		</style>
        <Helmet>
          <title>Post-Questionnaire</title>
        </Helmet>
        <Navigation role={role} />
        <TextHero childTitle={'Training Completed'} />
        <section
          style={{
            marginTop: '-100px'
          }}
        >
          <div className="container">
            <Row>
              <Col xs={10} xsOffset={1} md={8} mdOffset={2}>
                <h3 className="txt-blue text-center">
                  Congratulations: Training Completed
                </h3>
                <p>
                  Congratulations! You've now completed Identify, Assist, Refer.
                </p>
                <p>
                  Now that you have completed the training, please reassess your current knowledge and
                  confidence in being able to effectively Identify, Assist, and Refer someone you’re
                  concerned about. This will also help us to make improvements to this online training.
                  Thank you! <strong>Please note, the “submit” button will not appear until every question
                  is answered.</strong>
                </p>
                <p>
                  <span style={{ fontWeight: 900 }}>Post-Questionnaire</span><br />
                  Some questions appear on a Likert scale. On a scale of 1 to 5, 1 being strongly disagree
                  and 5 being strongly agree, please indicate your agreement with the following statements:
                </p>
              </Col>
            </Row>
          </div>
        </section>
        <section>
          <div className="container">
            <Row>
              <Col xs={10} xsOffset={1} md={8} mdOffset={2}>
                {renderQuestions}
                <p>
                  Thank you for completing Identify, Assist, Refer. We
                  welcome your feedback. Please email&nbsp;
                  <a
                    href="mailto:health.promotion@utoronto.ca"
                    rel="noreferrer noopener"
                    target="_blank"
                  >
                    health.promotion@utoronto.ca</a> with any suggestions or questions.
                </p>
              </Col>
            </Row>
          </div>
        </section>
        <section>
          <div className="container text-center">
            <Row>
              <Col xs={12} md={8} mdOffset={2}>
                <Button
                  className="btn btn-blue previous"
                  onClick={() => this.props.history.goBack()}
                >
                  Previous
                </Button>
                {checkAnswered() && (
                  <Button
                    className="btn btn-blue next"
                    onClick={this.onClickSubmit}
                  >
                    Submit
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}

TrainingCompletedPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

TrainingCompletedPage.defaultProps = {
  role: {}
};

TrainingCompletedPage.contextTypes = {
  router: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  responses: state.cache.responses,
  cache: state.cache,
  training: state.training
});
const TrainingCompleted = connect(
  mapStateToProps,
  allActions
)(TrainingCompletedPage);

export default reduxConnect.training(reduxConnect.role(TrainingCompleted));



// WEBPACK FOOTER //
// ./src/containers/TrainingCompleted/index.jsx